import * as React from 'react'
import { Pagination as PlumePagination } from 'plume-ui'
import uniq from 'lodash/uniq'
import { css } from '@emotion/react'

type Props = {
  page: number
  setPage: (page: number) => void
  limit: number
  count: number | null
  className?: string
}

export const Pagination: React.FC<Props> = (props) => {
  if (!props.count) {
    return null
  }
  const offset = (props.page - 1) * props.limit
  const total = Math.ceil(props.count / props.limit)
  const current = Math.floor(offset / props.limit)

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
      `}
      className={props.className}
    >
      <PlumePagination>
        <PlumePagination.Previous
          disabled={current === 0}
          as="a"
          onClick={() => {
            if (current === 0) {
              return
            }
            props.setPage(props.page - 1)
          }}
        />
        <PlumePagination.List>
          {pageNumbers(total, current).map((p, i) => (
            <React.Fragment key={i}>
              {p === -1 ? (
                <PlumePagination.Ellipsis />
              ) : (
                <PlumePagination.Item
                  key={p}
                  active={current === p}
                  onClick={() => {
                    props.setPage(p + 1)
                  }}
                >
                  <a>{p + 1}</a>
                </PlumePagination.Item>
              )}
            </React.Fragment>
          ))}
        </PlumePagination.List>
        <PlumePagination.Next
          disabled={current === total - 1}
          as="a"
          onClick={() => {
            if (current === total - 1) {
              return
            }
            props.setPage(props.page + 1)
          }}
        />
      </PlumePagination>
    </div>
  )
}

const FIXED_COUNT = 2
const MID_COUNT = 1

export const pageNumbers = (total: number, currnet: number): number[] => {
  const head = range(FIXED_COUNT)
  const mid = range(MID_COUNT * 2 + 1, currnet - MID_COUNT)
  const tail = range(FIXED_COUNT, total - FIXED_COUNT)

  const list = uniq([...head, ...mid, ...tail]).filter(
    (v) => v >= 0 && v < total
  )
  return insertEllipsis(list)
}

function insertEllipsis(list: number[]): number[] {
  const ret = [...list]
  for (let i = 0; i < ret.length - 1; i++) {
    if (ret[i + 1] - ret[i] !== 1) {
      ret.splice(i + 1, 0, -1)
      i += 1
    }
  }
  return ret
}

const range = (n: number, start: number = 0): number[] => {
  const list: number[] = []
  for (let i = start; i < start + n; i++) {
    list.push(i)
  }
  return list
}
